"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Always import {h} from preact
var preact_1 = require("preact");
var TargetSymptomsModule_1 = require("../components/TargetSymptomsModule/TargetSymptomsModule");
var targetNode = document.querySelector('.target-symptoms-module-section');
if (targetNode) {
    (0, preact_1.render)((0, preact_1.h)(TargetSymptomsModule_1.default, null), targetNode);
}
